<template>
  <div class="max-width">
    <div class="title-wrap">
      <span class="title">服务超市</span>
    </div>
    <ul class="service-wrap">
      <li v-for="item in marketList" :key="item.title" class="service-item content-wrap">
        <img class="bg-icon" :src="item.bg" alt="" />
        <div class="title-header">
          <img :src="item.icon" alt="" />
          <div class="title">
            <p>{{ item.title }}</p>
          </div>
        </div>
        <ul class="list-wrap">
          <li v-for="sub in item.serviceList" :key="sub.title" class="pointer" @click="handleGoPage(sub)">
            <el-popover v-if="sub.id == '1679833481647583234'" :visible="sub.showCode" placement="top">
              <img src="@/assets/images/青年人才驿站.png" width="250" alt="" />
              <div style="text-align: center">请使用微信扫码打开小程序</div>
              <template #reference>
                <span>{{ sub.title }}</span>
              </template>
            </el-popover>
            <span v-else>{{ sub.title }}</span>
          </li>
        </ul>
      </li>
    </ul>
    <!-- <div style="text-align: center; padding-top: 100px">
      <img width="280px" src="@/assets/images/page_none_default.png" alt="" />
      <div style="color: #333; font-size: 18px">服务更新中</div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ServiceMarket',
  data() {
    return {
      marketList: [
        {
          title: '政务服务',
          bg: require('@/assets/images/service-icon-1.png'),
          icon: require('@/assets/images/service-1.png'),
          titleEn: 'Government Service',
          serviceList: [
            // { title: '高层次人才认定', outLink: 'https://hrs.nbrc.com.cn/index.jsp' },
            // { title: '人才引进落户', link: '#' },
            // { title: '外国人工作许可证', outLink: 'https://fuwu.most.gov.cn/html/fwsx/wgrlhzq/' },
            // { title: '外国人居留签证办理', link: '#' },
            // { title: '公司设立登记', outLink: 'https://www.zjzwfw.gov.cn/zjservice/item/detail/index.do?localInnerCode=da580a51-5180-4738-9175-3942827a1d94' },
          ],
        },
        {
          title: '生活服务',
          bg: require('@/assets/images/service-icon-2.png'),
          icon: require('@/assets/images/service-2.png'),
          titleEn: 'Life Services',
          serviceList: [
            // { title: '子女入学', outLink: 'https://ryrx.nbsedu.com/site_zsbm/toppage.aspx' },
            // { title: '医疗保障', outLink: 'https://www.nbgzjk.cn/' },
            // { title: '旅游景点', link: '#' },
            // { title: '休闲健身', link: '#' },
            // { title: '出行服务', link: '#' },
          ],
        },
        {
          title: '安居服务',
          bg: require('@/assets/images/service-icon-3.png'),
          icon: require('@/assets/images/service-3.png'),
          titleEn: 'Secure Housing Services',
          serviceList: [
            // { title: '安居政策申领', outLink: 'https://hrs.nbrc.com.cn/index.jsp' },
            // { title: '青年人才驿站', outLink: 'https://nbyz.homeplus.cn/' },
            // { title: '住房公积金', outLink: 'http://zjw.ningbo.gov.cn/col/col1229126238/index.html' },
          ],
        },
        {
          title: '科创服务',
          bg: require('@/assets/images/service-icon-4.png'),
          icon: require('@/assets/images/service-4.png'),
          titleEn: 'Science and Technology Innovation Services',
          serviceList: [
            // { title: '科技项目申报', outLink: 'http://stbrain.kjj.ningbo.gov.cn/web/Public/bsdt.html' },
            // { title: '仪器设备共享', outLink: 'http://www.nb-yq.com/index.do' },
            // { title: '科技文献共享', outLink: 'http://www.nbsti.net/Public/html/index.html' },
          ],
        },
        {
          title: '助企服务',
          bg: require('@/assets/images/service-icon-5.png'),
          icon: require('@/assets/images/service-5.png'),
          titleEn: 'Enterprise Assistance Services',
          serviceList: [
            // { title: '企业政策申报', outLink: 'https://qyfw.jxj.ningbo.gov.cn/#/index/policyKnowledge' },
            // { title: '企业诉求办理', outLink: 'https://qyfw.jxj.ningbo.gov.cn/#/index/appealSubmit' },
            // { title: '中小企业服务', outLink: 'http://www.87188718.com/' },
            // { title: '三员助创服务', link: '#' },
          ],
        },
        {
          title: '金融服务',
          bg: require('@/assets/images/service-icon-6.png'),
          icon: require('@/assets/images/service-6.png'),
          titleEn: 'Financial Service',
          serviceList: [
            // { title: '人才保', link: '#' },
            // { title: '人才贷', link: '#' },
            // { title: '用汇便利', link: '#' },
            // { title: '投资基金', outLink: 'https://www.china-nbee.com​' },
            // { title: '投资基金', link: '#' },
          ],
        },
      ],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    handleGoPage(item) {
      // 青年人才驿站二维码显示隐藏逻辑，固定需求
      if (item.id == '1679833481647583234') {
        item.showCode = true
        return
      }
      if (item.infoType == 1) {
        window.open(item.originUrl)
      } else if (item.infoType == 2) {
        this.$router.push({ path: 'service-marketdetail', query: { id: item.id } })
      }
    },
    getList() {
      this.$http({ method: 'GET', url: '/zzmh/api/service/list' }).then((res) => {
        if (res.code === 0) {
          const data = res.data.list
          data.forEach((item) => {
            const typeItem = this.marketList.filter((item1) => item1.title == item.serviceType)[0]
            typeItem.serviceList.push(item)
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
